import request from "@/router/axios";

export const getList = (current, size, params) => {
  return request({
    url: "/api/blade-loanRepaymentPlan/loanRepaymentPlan/page",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

//list-by-information
export const listByInformation = (loanInformationId) => {
  return request({
    url: "/api/blade-loanRepaymentPlan/loanRepaymentPlan/list-by-information",
    method: "get",
    params: {
      loanInformationId,
    },
  });
};


export const getDetail = (id) => {
  return request({
    url: "/api/blade-loanRepaymentPlan/loanRepaymentPlan/detail",
    method: "get",
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/blade-loanRepaymentPlan/loanRepaymentPlan/remove",
    method: "post",
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: "/api/blade-loanRepaymentPlan/loanRepaymentPlan/submit",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/blade-loanRepaymentPlan/loanRepaymentPlan/submit",
    method: "post",
    data: row,
  });
};

export const submitRepaymentPlan = (row) => {
  return request({
    url: "/api/blade-loanRepaymentPlan/loanRepaymentPlan/submit-repayment-plan",
    method: "post",
    data: row,
  });
};
